import React from 'react';
import { Navbar, Nav } from 'react-bootstrap';

import { useSelector } from 'react-redux';
import { getUserStore, getDefaultAccountKey } from '../app/slices/UserSlice';

const LeftNav = (props) => {
  const user = useSelector(getUserStore);
  const isAuth = user ? true : false;

  const defaultAccountKey = useSelector(getDefaultAccountKey);
  let accountKey = props.accountKey ? props.accountKey : defaultAccountKey;

  //appkey? 
  let appKey = props?.appKey != "" ? props.appKey : null;
  let isAnalytics = props?.isAnalytics == true ? true : false;
  let isAppAnalytics = props?.isAppAnalytics == true ? true : false;
  let startFactDate = props.startFactDate;
  let endFactDate = props.endFactDate;

  let dateRange = "";
  if(startFactDate != null && startFactDate != ""){
    dateRange = `/${startFactDate}`;
    if(endFactDate != null && endFactDate != "") {
      dateRange += `/${endFactDate}`;
    }
  }

  //

  //bg="dark"
  return (
    <Navbar className="col-md-2 col-lg-2 d-md-block sidebar" expand="md" variant="light" id="sidenav">
      <Navbar.Toggle aria-controls="sidebar-nav" />
      <Navbar.Collapse id="sidebar-nav">
        <Nav className="flex-column" >
          {
            isAuth ?
              <>

                <Nav.Item>
                  <Nav.Link href={`/account/${accountKey}/dashboard${dateRange}`}>Dashboard</Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link href={`/account/${accountKey}/analytics`}>Analytics</Nav.Link>
                </Nav.Item>
                {
                  isAnalytics ?
                    <>
                      <Nav className="flex-column ms-3 sidebar-submenu" id="analytics-nav">
                        {/* 
                        <Nav.Item>
                          <Nav.Link href={`/account/${accountKey}/analytics/dashboard${dateRange}`}>Account Stats</Nav.Link>
                        </Nav.Item>
                        
                        <Nav.Item>
                          <Nav.Link href={`/account/${accountKey}/analytics${dateRange}`}>Prompts</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link href={`/account/${accountKey}/analytics${dateRange}`}>Responses</Nav.Link>
                        </Nav.Item>
                        */}
                      </Nav>
                    </>
                    : <></>
                }
                {
                  isAppAnalytics ?
                    <>
                      <Nav className="flex-column ms-3 sidebar-submenu" id="analytics-nav">
                        <Nav.Item>
                          <Nav.Link href={`/account/${accountKey}/analytics/app/${appKey}/summary${dateRange}`}>Summary</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link href={`/account/${accountKey}/analytics/app/${appKey}/prompts${dateRange}`}>Prompts</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link href={`/account/${accountKey}/analytics/app/${appKey}/promptclusters${dateRange}`}>Prompt Clusters</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link href={`/account/${accountKey}/analytics/app/${appKey}/responses${dateRange}`}>Responses</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link href={`/account/${accountKey}/analytics/app/${appKey}/responseclusters${dateRange}`}>Response Clusters</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link href={`/account/${accountKey}/analytics/app/${appKey}/interactions${dateRange}`}>Interactions</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link href={`/account/${accountKey}/analytics/app/${appKey}/transcripts${dateRange}`}>Transcripts</Nav.Link>
                        </Nav.Item>
                        
                        <Nav.Item>
                          <Nav.Link href={`/account/${accountKey}/analytics/app/${appKey}/models${dateRange}`}>Model Usage</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link href={`/account/${accountKey}/analytics/app/${appKey}/guardrails${dateRange}`}>Guardrails</Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </>
                    : <></>
                }
                <Nav.Item>
                  <Nav.Link href={`/account/${accountKey}/apps`}>Apps</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link href={`/account/${accountKey}/experiments/create`}>Experiments</Nav.Link>
                </Nav.Item>
              </>
              :
              <>
                <Nav.Item>
                  <Nav.Link href="/signup">Signup</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link href="/login">Login</Nav.Link>
                </Nav.Item>
              </>
          }
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  )
}

export default LeftNav;
